"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEntityGroup = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const isValidEntityGroup = (x) => (0, iotv_v3_types_1.isValidBusinessObject)(x) && x.type === 'Group' && typeof x.supportedType === 'string';
exports.isValidEntityGroup = isValidEntityGroup;
